import request, { buildFiles, UPLOAD_HEADERS } from '../../../../common/utils/request';

const fetch = id => request('get', `/design/projects/${id}.json`);

const update = (project, params) =>
  request('put', `/design/projects/${project.id}`, { project: params });

const uploadImages = (project, files, key) => {
  const data = buildFiles(files, key);
  return request('post', `/design/projects/${project.id}/upload_images`, data, {
    headers: UPLOAD_HEADERS,
  });
};

const deleteImage = (project, fileId) =>
  request('delete', `/design/projects/${project.id}/destroy_image/${fileId}`);

const imageNotes = id => request('get', `/design/projects/${id}/image_notes`);

const updateNote = (project, note) => {
  const data = { project: { mbr_note_attributes: { id: note.id, text: note.text } } };
  return request('patch', `/design/projects/${project.id}`, data);
};

const updateNoteShopper = (project, note) => {
  const data = { project: { shopper_notes: note } };
  return request('patch', `/design/projects/${project.id}`, data);
};

const setClient = (project, client) => {
  const data = { project: { customer_id: client.id } };
  return request('put', `/admin/projects/${project.id}`, data);
};

const setAdmin = (project, admin) => {
  const data = { project: { admin_id: admin.id } };
  return request('put', `/admin/projects/${project.id}`, data);
};

const setPersonalShopper = (project, personaShopper) => {
  const data = { project: { personal_shopper_id: personaShopper.id } };
  return request('put', `/admin/projects/${project.id}`, data);
};

const currentMoodboard = project =>
  request('get', `/design/projects/${project.id}/current_moodboard`);

export default {
  fetch,
  update,
  uploadImages,
  deleteImage,
  imageNotes,
  updateNote,
  updateNoteShopper,
  setAdmin,
  setClient,
  setPersonalShopper,
  currentMoodboard,
};



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Workdesk/api/project.js